import React from "react";
import AdminLayout from "./AdminLayout";
import PaymentManagement from "../../components/Admin/PaymentManagement";

const PaymentsPage = () => {
  return (
    <AdminLayout>
      <PaymentManagement />
    </AdminLayout>
  );
};

export default PaymentsPage;
